<template>
  <div class="event-shell">
    <EventBreadcrumb :items="breadcrumbItems" />

    <div v-if="loading" class="card page-state">
      Memuat detail event...
    </div>

    <div v-else-if="loadError" class="card page-state page-state--error">
      <strong>Detail event tidak dapat dimuat.</strong>
      <span>{{ loadError }}</span>
      <router-link to="/form-registrasi" v-if="loadError === 'Anda belum menjadi member'">
        <button type="button" class="btn-primary">
          Daftar Sekarang
        </button>
      </router-link>
      <button type="button" class="btn-outline" @click="getEventDetail" v-else>
        Coba lagi
      </button>
    </div>

    <template v-else>
      <!-- ?view=detail-closed atau ?view=detail-open -->
      <section
        v-if="view === 'detail-closed' || view === 'detail-open'"
        class="card detail-layout"
      >
        <img
          class="event-poster"
          :src="activeEvent.banner_url"
          :alt="activeEvent.event_name"
        >

        <div class="detail-content">
          <span class="eyebrow">Ketentuan Acara</span>
          <h1>{{ activeEvent.event_name }}</h1>
          <p class="muted">{{ activeEvent.description }}</p>

          <div class="pill-row">
            <span class="pill">
              {{ formatDate(activeEvent.redemption_start) }}
            </span>
            <span class="pill">
              {{ eventLocation }}
            </span>
          </div>

          <template v-if="view === 'detail-closed'">
            <div class="info-box">
              <span aria-hidden="true" style="margin-top: 2px;">
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 15 15">
                  <path d="M0 0h15v15H0z" fill="none" />
                  <path fill="currentColor" d="M7.501.978c1.074 0 1.968.345 2.59 1.014c.616.664.909 1.587.909 2.642V6h1a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h1V4.636c0-1.055.293-1.979.91-2.643c.622-.67 1.517-1.015 2.591-1.015M3 13h9V7H3zM7.501 1.978c-.855 0-1.461.27-1.857.696C5.243 3.105 5 3.76 5 4.636V6h5V4.634c0-.877-.241-1.531-.642-1.962c-.395-.426-1.001-.694-1.857-.694" />
                </svg>
              </span>
              <span>
                Pendaftaran event ini belum dibuka atau sudah ditutup.
                Silakan periksa kembali periode pendaftarannya.
              </span>
            </div>

            <button type="button" class="btn-outline" disabled>
              <span style="margin-top: 2px;">
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path fill="currentColor" d="M12 20a8 8 0 0 0 8-8a8 8 0 0 0-8-8a8 8 0 0 0-8 8a8 8 0 0 0 8 8m0-18a10 10 0 0 1 10 10a10 10 0 0 1-10 10C6.47 22 2 17.5 2 12A10 10 0 0 1 12 2m.5 5v5.25l4.5 2.67l-.75 1.23L11 13V7z" />
                </svg>
              </span>
              Pendaftaran tidak tersedia
            </button>
          </template>

          <template v-else>
            <div class="info-box info-box--success">
              <svg xmlns="http://www.w3.org/2000/svg" width="1.3em" height="1.3em" viewBox="0 0 24 24">
                <path d="M0 0h24v24H0z" fill="none" />
                <path fill="currentColor" d="m9.55 18l-5.7-5.7l1.425-1.425L9.55 15.15l9.175-9.175L20.15 7.4z" />
              </svg>
              <span>
                Periode pendaftaran sudah dibuka. Pastikan data
                keanggotaan Anda lengkap sebelum melanjutkan.
              </span>
            </div>

            <button type="button" class="btn-primary" style="display: flex; align-items: center; gap: 8px;" @click="goToRegistration">
              <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 1024 1024">
                <path d="M0 0h1024v1024H0z" fill="none" />
                <path fill="currentColor" d="M754.8 480H160a32 32 0 1 0 0 64h594.8L521.3 777.3a32 32 0 0 0 45.4 45.4l288-288a32 32 0 0 0 0-45.4l-288-288a32 32 0 1 0-45.4 45.4z" />
              </svg>

              Daftar Event
            </button>
          </template>
        </div>
      </section>

      <!-- ?view=success -->
      <section v-else-if="view === 'success'" class="result-wrap">
        <article class="card result-card">
          <div class="result-icon result-icon--success">
            <svg xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" viewBox="0 0 24 24">
              <path d="M0 0h24v24H0z" fill="none" />
              <path fill="currentColor" d="m9.55 18l-5.7-5.7l1.425-1.425L9.55 15.15l9.175-9.175L20.15 7.4z" />
            </svg>
          </div>
          <h1>Pendaftaran Berhasil!</h1>

          <p class="muted result-description">
            Terima kasih. Pendaftaran Anda untuk
            <strong>{{ activeEvent.event_name }}</strong> telah kami terima.
            Silakan kembali pada tanggal pengumuman untuk melihat hasilnya.
          </p>

          <div class="pill-row result-pills" style="">
            <span class="pill" style="display: flex; align-items: center; gap: 8px;">
              <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                <path d="M0 0h24v24H0z" fill="none" />
                <g fill="currentColor">
                  <path d="M7.75 2.5a.75.75 0 0 0-1.5 0v1.58c-1.44.115-2.384.397-3.078 1.092c-.695.694-.977 1.639-1.093 3.078h19.842c-.116-1.44-.398-2.384-1.093-3.078c-.694-.695-1.639-.977-3.078-1.093V2.5a.75.75 0 0 0-1.5 0v1.513C15.585 4 14.839 4 14 4h-4c-.839 0-1.585 0-2.25.013z" />
                  <path fill-rule="evenodd" d="M2 12c0-.839 0-1.585.013-2.25h19.974C22 10.415 22 11.161 22 12v2c0 3.771 0 5.657-1.172 6.828S17.771 22 14 22h-4c-3.771 0-5.657 0-6.828-1.172S2 17.771 2 14zm15 2a1 1 0 1 0 0-2a1 1 0 0 0 0 2m0 4a1 1 0 1 0 0-2a1 1 0 0 0 0 2m-4-5a1 1 0 1 1-2 0a1 1 0 0 1 2 0m0 4a1 1 0 1 1-2 0a1 1 0 0 1 2 0m-6-3a1 1 0 1 0 0-2a1 1 0 0 0 0 2m0 4a1 1 0 1 0 0-2a1 1 0 0 0 0 2" clip-rule="evenodd" />
                </g>
              </svg>
              Pengumuman: {{ formatDate(activeEvent.winner_announcement_date) }}
            </span>
            <span class="pill" style="display: flex; align-items: center; gap: 8px;">
              <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                <path d="M0 0h24v24H0z" fill="none" />
                <path fill="currentColor" d="M14.826 19A3 3 0 0 1 12 21a3 3 0 0 1-2.825-2zM12 2a7 7 0 0 1 7 7v3.528a1 1 0 0 0 .106.447l1.717 3.433A1.1 1.1 0 0 1 19.838 18H4.162a1.1 1.1 0 0 1-.984-1.592l1.717-3.433A1 1 0 0 0 5 12.528V9a7 7 0 0 1 7-7" />
              </svg>
              Notifikasi via aplikasi Perindo
            </span>
          </div>

          <div class="info-box">
            <span aria-hidden="true" style="margin-top: 3px;">
              <svg xmlns="http://www.w3.org/2000/svg" width="1.3em" height="1.3em" viewBox="0 0 16 16">
                <path d="M0 0h16v16H0z" fill="none" />
                <path fill="currentColor" fill-rule="evenodd" d="M12 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 4 12.5v-9A1.5 1.5 0 0 1 5.5 2h5A1.5 1.5 0 0 1 12 3.5m-1.5-3a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3h-5a3 3 0 0 1-3-3v-9a3 3 0 0 1 3-3zM6.25 11a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5z" clip-rule="evenodd" />
              </svg>
            </span>
            <span>
              Pakai <strong>Aplikasi Perindo</strong> untuk mendapat <strong>pengingat otomatis + tautan langsung</strong> ke halaman pengumuman, dan pengingat hari-H bila Anda terpilih.
            </span>
          </div>
        </article>
      </section>

      <!-- ?view=rejected -->
      <section v-else-if="view === 'rejected'" class="result-wrap">
        <article class="card result-card">
          <div class="result-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
              <path d="M0 0h24v24H0z" fill="none" />
              <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                <path d="M3 9a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm9-1v13" />
                <path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7m2.5-4a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5a2.5 2.5 0 0 1 0 5" />
              </g>
            </svg>
          </div>
          <h1>Mohon Maaf, Anda Belum Terpilih</h1>

          <p class="muted result-description">
            Kuota event ini terbatas dan Anda belum berkesempatan menerima voucher kali ini. Data Anda sudah valid - teruslah mengikuti Event Mitra Perindo berikutnya, kesempatan Anda tetap terbuka.
          </p>

          <div class="info-box" style="display: flex; gap: 8px;">
            <span aria-hidden="true" style="margin-top: 2px;">
              <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                <path d="M0 0h24v24H0z" fill="none" />
                <g fill="none" stroke="currentColor" stroke-width="2.5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M6 19v-9a6 6 0 0 1 6-6v0a6 6 0 0 1 6 6v9M6 19h12M6 19H4m14 0h2m-9 3h2" />
                  <circle cx="12" cy="3" r="1" />
                </g>
              </svg>
            </span>
            <span>
              Aktifkan notifikasi di Aplikasi Perindo agar tidak ketinggalan event tebus murah berikutnya di wilayah Anda.
            </span>
          </div>
        </article>
      </section>

      <!-- ?view=invalid&reason=... -->
      <section v-else-if="view === 'invalid'" class="result-wrap">
        <article class="card result-card">
          <div class="result-icon result-icon--warning">⚠</div>
          <h1>Data Anda Perlu Diperbaiki</h1>

          <p class="muted result-description">
            Anda belum dapat ditetapkan sebagai penerima karena data
            keanggotaan belum tervalidasi pada event ini.
          </p>

          <div class="reason-box" style="display: flex; gap: 8px;">
            <span aria-hidden="true" style="margin-top: 2px;">
              <svg xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" viewBox="0 0 32 32">
                <path d="M0 0h32v32H0z" fill="none" />
                <path fill="currentColor" d="M16 2C8.2 2 2 8.2 2 16s6.2 14 14 14s14-6.2 14-14S23.8 2 16 2m0 26C9.4 28 4 22.6 4 16S9.4 4 16 4s12 5.4 12 12s-5.4 12-12 12" />
                <path fill="currentColor" d="M21.4 23L16 17.6L10.6 23L9 21.4l5.4-5.4L9 10.6L10.6 9l5.4 5.4L21.4 9l1.6 1.6l-5.4 5.4l5.4 5.4z" />
              </svg>
            </span>
            <span><strong>Alasan:</strong> {{ invalidReason }}</span>
          </div>

          <div class="info-box" style="display: flex; gap: 8px;">
            <span aria-hidden="true" style="margin-top: 2px;">
              <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 1024 1024">
                <path d="M0 0h1024v1024H0z" fill="none" />
                <path fill="currentColor" d="M512 0C229.232 0 0 229.232 0 512c0 282.784 229.232 512 512 512c282.784 0 512-229.216 512-512C1024 229.232 794.784 0 512 0m0 961.008c-247.024 0-448-201.984-448-449.01c0-247.024 200.976-448 448-448s448 200.977 448 448s-200.976 449.01-448 449.01m204.336-636.352L415.935 626.944l-135.28-135.28c-12.496-12.496-32.752-12.496-45.264 0c-12.496 12.496-12.496 32.752 0 45.248l158.384 158.4c12.496 12.48 32.752 12.48 45.264 0c1.44-1.44 2.673-3.009 3.793-4.64l318.784-320.753c12.48-12.496 12.48-32.752 0-45.263c-12.512-12.496-32.768-12.496-45.28 0" />
              </svg>
            </span>
            <span>
              <strong>Cara memperbaiki:</strong>
              Perbarui foto KTP Anda dengan foto yang jelas & terbaca melalu menu Pendaftaran/Profil. Setelah data valid, Anda berpeluang menang pada event berikutnya.
              <span style="color: #7a7979;">(Foto Diri yang buram tidak menjadi masalah - itu bukan syarat verifikasi)</span>
            </span>
          </div>

          <button type="button" class="btn-primary" @click="goToUpdateProfile" style="display: flex; align-items: center; gap: 8px; margin-left: auto; margin-right: auto;">
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 1024 1024">
              <path d="M0 0h1024v1024H0z" fill="none" />
              <path fill="currentColor" d="M754.8 480H160a32 32 0 1 0 0 64h594.8L521.3 777.3a32 32 0 0 0 45.4 45.4l288-288a32 32 0 0 0 0-45.4l-288-288a32 32 0 1 0-45.4 45.4z" />
            </svg>
            Perbarui Data Sekarang
          </button>
        </article>
      </section>

      <!-- ?view=voucher&code=CXDF-DCD -->
      <section v-else-if="view === 'voucher'" class="voucher-layout">
        <article class="card voucher-card">
          <header>
            <span>VOUCHER TEBUS MURAH</span>
            <h2>Anda Terpilih</h2>
          </header>

          <canvas
            v-if="voucherCode"
            ref="voucherQrCanvas"
            class="qr-box"
            role="img"
            :aria-label="`QR voucher ${voucherCode}`"
          ></canvas>
          <div v-else class="qr-box qr-box--empty">
            Kode voucher belum tersedia
          </div>
          <strong class="voucher-code">{{ voucherCode || '-' }}</strong>
          <p>Tunjukkan QR ini kepada Mitra Perindo di lokasi.</p>
        </article>

        <article class="card voucher-detail">
          <h2>Detail Voucher</h2>

          <dl>
            <div>
              <dt>Acara</dt>
              <dd>{{ activeEvent.event_name }}</dd>
            </div>
            <div>
              <dt>Tanggal</dt>
              <dd>{{ formatDate(activeEvent.redemption_start) }}</dd>
            </div>
            <div>
              <dt>Lokasi</dt>
              <dd>{{ eventLocation }}</dd>
            </div>
          </dl>

          <h3>Data Anggota</h3>

          <div class="member-voucher">
            <dl>
              <div>
                <dt>No. KTA</dt>
                <dd>{{ profile.member_no || '-' }}</dd>
              </div>
              <div>
                <dt>No. KTP</dt>
                <dd>{{ profile.nik || '-' }}</dd>
              </div>
              <div>
                <dt>Nama</dt>
                <dd>{{ profile.nama_lengkap || '-' }}</dd>
              </div>
            </dl>

            <div class="ktp-placeholder">
              <img v-if="winnerData.ktp_url" :src="winnerData.ktp_url" alt="KTP anggota">
              <span v-else>Foto KTP</span>
            </div>
          </div>

          <div class="reason-box">
            <span aria-hidden="true">
              <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                <path d="M0 0h24v24H0z" fill="none" />
                <path fill="currentColor" d="M1 21L12 2l11 19zm3.45-2h15.1L12 6zm8.263-1.287Q13 17.425 13 17t-.288-.712T12 16t-.712.288T11 17t.288.713T12 18t.713-.288M11 15h2v-5h-2zm1-2.5" />
              </svg>
            </span>
            <span>
              <strong>Wajib:</strong> tunjukkan halaman ini dan bawa
              <strong>KTP asli</strong> untuk validasi di lokasi.
            </span>
          </div>
        </article>
      </section>
    </template>
  </div>
</template>

<script>
import axios from 'axios'
import dayjs from 'dayjs'
import QRCode from 'qrcode'
import EventBreadcrumb from '@/components/EventBreadcrumb.vue'

const ALLOWED_VIEWS = [
  'detail-closed',
  'detail-open',
  'success',
  'rejected',
  'invalid',
  'voucher',
  'registration'
]

export default {
  name: 'EventDetailPage',

  components: {
    EventBreadcrumb
  },

  data () {
    return {
      activeEvent: {},
      profile: {},
      loading: false,
      loadError: '',
      winnerData: {}
    }
  },

  computed: {
    eventId () {
      return this.$route.params.id
    },
    view () {
      const requestedView = this.$route.query.view || this.$route.query.mock
      return ALLOWED_VIEWS.includes(requestedView)
        ? requestedView
        : 'detail-closed'
    },
    eventLocation () {
      return [this.activeEvent.district_name, this.activeEvent.city_name]
        .filter(Boolean)
        .join(', ') || '-'
    },
    invalidReason () {
      return this.$route.query.reason ||
        'Foto KTP tidak jelas atau data belum dapat diverifikasi.'
    },
    voucherCode () {
      return this.unwrapNullable(this.winnerData?.voucher_code) ||
        this.unwrapNullable(this.winnerData?.voucherCode) ||
        this.unwrapNullable(this.winnerData?.code) ||
        this.$route.query.code || ''
    },
    breadcrumbItems () {
      const items = [
        { label: 'Beranda', to: '/dashboard' },
        { label: 'Event Perindo', to: { name: 'event-list' } },
        { label: this.activeEvent.event_name || 'Detail Event' }
      ]

      if (this.view === 'voucher') items.push({ label: 'Voucher Saya' })
      return items
    }
  },

  watch: {
    '$route.params.id' () {
      this.loadPageData()
    },
    activeEvent (newVal) {
      this.checkEventStatus(newVal, this.winnerData)
    },
    winnerData: {
      handler (newVal) {
        this.checkEventStatus(this.activeEvent, newVal)
      },
      deep: true
    },
    voucherCode () {
      this.queueVoucherQrRender()
    },
    view (newView) {
      if (newView === 'voucher') this.queueVoucherQrRender()
    }
  },

  mounted () {
    this.loadPageData()
  },

  methods: {
    queueVoucherQrRender () {
      if (this.view !== 'voucher' || !this.voucherCode) return
      this.$nextTick(() => this.renderVoucherQr())
    },
    async renderVoucherQr () {
      const canvas = this.$refs.voucherQrCanvas
      if (!canvas || !this.voucherCode) return

      try {
        await QRCode.toCanvas(canvas, String(this.voucherCode), {
          width: 190,
          margin: 1,
          errorCorrectionLevel: 'M',
          color: {
            dark: '#000000',
            light: '#ffffff'
          }
        })
      } catch (error) {
        console.error('Gagal membuat QR voucher:', error)
      }
    },
    checkEventStatus (event, winner) {
      if (event?.is_registered && (event?.status === 'REGISTRATION_OPEN' || event?.status === 'REGISTRATION_CLOSED')) {
        this.setView('success')
      }

      if (event?.is_registered && winner?.status === 'ACCEPTED' && (event?.status === 'ANNOUNCED' || event?.status === 'REDEMPTION_OPEN' || event?.status === 'REDEMPTION_END')) {
        this.setView('voucher')
      }

      if (event?.is_registered && winner?.status === 'REJECTED' && winner?.reason && (event?.status === 'ANNOUNCED' || event?.status === 'REDEMPTION_OPEN' || event?.status === 'REDEMPTION_END' || event?.status === 'ENDED')) {
        this.setView('invalid')
      }

      if (event?.is_registered && (event?.status === 'ENDED' || event?.status === 'ANNOUNCED' || event?.status === 'REDEMPTION_OPEN' || event?.status === 'REDEMPTION_END') && (winner?.status === 'PENDING' || winner?.status === 'REJECTED')) {
        this.setView('rejected')
      }
    },
    unwrapNullable (value) {
      if (value === null || value === undefined) return null
      if (typeof value !== 'object') return value
      if ('Valid' in value && value.Valid === false) return null
      if ('String' in value) return value.String
      if ('Int32' in value) return value.Int32
      if ('Int64' in value) return value.Int64
      if ('Bool' in value) return value.Bool
      return value
    },
    formatDate (date) {
      return date ? dayjs(date).format('DD MMM YYYY') : '-'
    },
    resolveDefaultView (status) {
      return status === 'REGISTRATION_OPEN'
        ? 'detail-open'
        : 'detail-closed'
    },
    async loadPageData () {
      await Promise.all([this.getEventDetail(), this.getProfile(), this.getWinnerData()])

      if (!this.$route.query.view && !this.$route.query.mock && this.activeEvent.status) {
        await this.setView(this.resolveDefaultView(this.activeEvent.status))
      }

      this.queueVoucherQrRender()
    },
    async getEventDetail () {
      this.loading = true
      this.loadError = ''

      try {
        const response = await axios.get(`member/event-vouchers/member/${this.eventId}`)
        const payload = response?.data?.data ?? response?.data ?? {}
        this.activeEvent = Array.isArray(payload) ? (payload[0] || {}) : payload
      } catch (error) {
        this.loadError = error?.response?.data?.message || error.message ||
          'Terjadi kesalahan saat mengambil detail event.'
      } finally {
        this.loading = false
      }
    },

    async getWinnerData () {
      try {
        const res = await axios.get(`member/event-vouchers/${this.eventId}/winner`)
        this.winnerData = res?.data?.data
      } catch (error) {
        console.error('Terjadi kesalahan')
      }
    },

    async getProfile () {
      try {
        const { data: rawProfile } = await axios.get('member/member')
        this.profile = {
          ...rawProfile,
          member_no: this.unwrapNullable(rawProfile.member_no),
          nik: this.unwrapNullable(rawProfile.nik),
          nama_lengkap: this.unwrapNullable(rawProfile.nama_lengkap),
          ktp_url: this.unwrapNullable(rawProfile.ktp_url)
        }
      } catch (error) {
        this.profile = {}
      }
    },
    setView (view) {
      if (!ALLOWED_VIEWS.includes(view)) return Promise.resolve()

      return this.$router.replace({
        name: 'event-detail',
        params: { id: this.eventId },
        query: {
          ...this.$route.query,
          view
        }
      })
    },
    goToRegistration () {
      this.$router.push({
        name: 'event-voucher-register',
        params: { eventId: this.eventId }
      })
    },
    goToUpdateProfile () {
      this.$router.push('/dashboard/profil')
    }
  }
}
</script>

<style scoped>
* { box-sizing: border-box; }

.event-shell {
  min-height: calc(100vh - 60px);
  color: #172852;
}

.card {
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 10px 28px rgba(20, 37, 80, .04);
}

.page-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 40px 20px;
  color: #6f7787;
  text-align: center;
}

.page-state--error { color: #b53a3a; }

.detail-layout {
  display: grid;
  grid-template-columns: minmax(290px, 41%) 1fr;
  gap: 26px;
  padding: 20px;
}

.event-poster {
  width: 100%;
  border-radius: 10px;
  object-fit: cover;
  max-height: 24rem;
}

.detail-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.detail-content h1,
.result-card h1 {
  margin: 10px 0 8px;
  font-size: 29px;
  line-height: 1.2;
}

.eyebrow {
  color: #64718a;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: .08em;
  text-transform: uppercase;
}

.muted { color: #6f7787; line-height: 1.55; }

.pill-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 14px 0 18px;
}

.pill {
  padding: 8px 13px;
  border-radius: 999px;
  background: #eef2f7;
  color: #4d5a72;
  font-size: 12px;
  font-weight: 700;
}

.btn-primary,
.btn-outline {
  min-height: 42px;
  padding: 0 18px;
  border-radius: 9px;
  cursor: pointer;
  font-weight: 800;
}

.btn-primary { border: 0; background: #192e62; color: #fff; }
.btn-outline { border: 1px solid #dfe5ee; background: #fff; color: #667188; }
.btn-outline:disabled { cursor: not-allowed; opacity: .7; }

.info-box,
.reason-box {
  margin-top: 8px;
  display: flex;
  gap: 4px;
  width: 100%;
  margin-bottom: 16px;
  padding: 15px 16px;
  border-radius: 12px;
  font-size: 13px;
  line-height: 1.55;
  text-align: left;
}

.info-box { background: #edf3ff; color: #42547c; }
.info-box--success { background: #e8f7ef; color: #197346; display: flex; gap: 8px; align-items: start;}
.reason-box { background: #ffeded; color: #c93535; }

.result-wrap {
  display: flex;
  justify-content: center;
  padding: 18px 0;
}

.result-card {
  width: min(590px, 100%);
  padding: 38px 60px;
  text-align: center;
}

.result-icon {
  display: grid;
  place-items: center;
  width: 82px;
  height: 82px;
  margin: 0 auto 18px;
  border-radius: 50%;
  background: #eef3ff;
  font-size: 34px;
}

.result-icon--success { background: #e8f7ef; color: #1e9b59; }
.result-icon--warning { background: #fff2d6; color: #bd7d0a; }
.result-description { max-width: 470px; margin: 0 auto; }
.result-pills { justify-content: center; }

.voucher-layout {
  display: grid;
  grid-template-columns: minmax(300px, 44%) 1fr;
  gap: 18px;
}

.voucher-card {
  height: max-content;
  overflow: hidden;
  text-align: center;
}

.voucher-card header { padding: 20px; background: #152956; color: #fff; }
.voucher-card header span {
  display: inline-block;
  padding: 7px 12px;
  border-radius: 7px;
  background: #f6bc2f;
  color: #172852;
  font-size: 11px;
  font-weight: 900;
}
.voucher-card header h2 { margin: 12px 0 0; }
.voucher-card > p { padding: 0 20px 20px; color: #7b8494; font-size: 13px; }
.voucher-code { display: block; color: #172852; letter-spacing: .08em; }

.qr-box {
  display: block;
  width: 190px;
  height: 190px;
  margin: 24px auto 10px;
  padding: 4px;
  border: 1px solid #e2e7ee;
  border-radius: 12px;
  background: #fff;
}

.qr-box--empty {
  display: grid;
  place-items: center;
  box-sizing: border-box;
  color: #7b8494;
  font-size: 12px;
  text-align: center;
}

.voucher-detail { padding: 20px; }
.voucher-detail h2,
.voucher-detail h3 { margin-top: 0; }
.voucher-detail dl { margin: 0 0 16px; }
.voucher-detail dl > div {
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: 14px;
  padding: 13px 0;
  border-bottom: 1px dashed #dfe4ec;
}

dt { color: #7a8394; }
dd { margin: 0; color: #182956; font-weight: 800; text-align: right; }

.member-voucher {
  display: grid;
  grid-template-columns: 1fr 220px;
  gap: 16px;
  align-items: center;
}

.ktp-placeholder {
  display: grid;
  place-items: center;
  min-height: 120px;
  overflow: hidden;
  border: 1px solid #dbe1eb;
  border-radius: 10px;
  background: #f6f8fb;
  color: #7b8494;
  font-size: 12px;
}

.ktp-placeholder img { width: 100%; height: 100%; object-fit: cover; }

@media (max-width: 900px) {
  .detail-layout,
  .voucher-layout,
  .member-voucher { grid-template-columns: 1fr; }
}

@media (max-width: 640px) {
  .event-shell { padding: 12px; }
  .detail-layout,
  .voucher-detail { padding: 14px; }
  .result-card { padding: 28px 20px; }
  .detail-content h1,
  .result-card h1 { font-size: 23px; }
  .voucher-detail dl > div { grid-template-columns: 95px 1fr; }
}
</style>
